import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const EstudiantesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Estudiantes</PageTitle>
      <View />
    </>
  );
};

export { EstudiantesPage };
